module.exports = __webpack_public_path__ + "assets/img/wxgzh.c8da34b2.jpg";